<div *ngIf="!registration">
    <header  *ngIf="!showLogout">
        <img class="headerLogo" src="../../../../assets/logo.jpg">
        <!-- <mat-icon *ngIf="showLogout" class="headerIcon" (click)="logout()">exit_to_app</mat-icon> -->
    </header> 
    <div class="headerFixed" *ngIf="showLogout && !isMobile">
        <img class="headerLogo" src="../../../../assets/logo.jpg">
        <span class="body2">{{descripcionUsuario}}</span>
        <mat-icon class="headerIcon" (click)="logout()">exit_to_app</mat-icon>
    </div>

    <header *ngIf="showLogout && isMobile">
        <app-navbar></app-navbar>
        <img class="headerLogoMobile" src="../../../../assets/logo.jpg">
        <mat-icon class="headerIconMobile" (click)="logout()">exit_to_app</mat-icon>
    </header>
</div>
    
<header  *ngIf="registration">
    <img class="headerLogo" src="../../../../assets/logo.jpg">
    <p *ngIf="!isMobile" class="subtitle2Header"> {{'registration.header' | translate}} </p>
    <mat-icon class="headerIcon" (click)="logout()">exit_to_app</mat-icon>
</header>